/* eslint-disable max-len */
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons"
import { Button, Form } from "antd"
import Styles from "./styles.module.css"
import { UploadComponentAntdCompatibilityWrapper } from "components/upload/UploadImageAntdCompatibilityWrapper"

type Props = {
  countryIndex: number;
  notificationsPerGameArrayIndex: number;
  notificationIndex: number;
};

export const SourceImagesEditor = ({ countryIndex }: Props) => {
  return (
    <Form.List name={[countryIndex, "imageSources"]}>
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name: imageSourceIndex, ...restField }) => (
            <div key={key} style={{ marginBottom: 24 }}>
              <div className={Styles.imageUploadWrapper}>
                <Form.Item
                  {...restField}
                  name={[imageSourceIndex, "src"]}
                >
                  <UploadComponentAntdCompatibilityWrapper />
                </Form.Item>
                <Button
                  type="primary"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => remove(imageSourceIndex)}
                />
              </div>
            </div>
          ))}
          <Button type="primary" icon={<PlusOutlined />} onClick={() => add({ src: "" })}>
            Add new image variant
          </Button>
        </>
      )}
    </Form.List>
  )
}
